<template>
  <check-base-layout
    :check-info-data="checkFrom"
    :pagetitle="pagetitle"
    :show-mark="false"
  >
    <template>
      <pact-module
        :target-url="checkFrom.sourceFile"
        :origin-url="checkFrom.stampFile"
      ></pact-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module
            :check-data="checkFrom.systemFlowRunAuditOrgVo"
          ></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'

export default {
  name: 'poPactsealCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '采购合同盖章审批'
    },
    isreturn: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.getpactSource()
  },
  methods: {
    getpactSource() {
      const { snaId } = this
      if (!this.isreturn) {
        checkApi
          .getPoPactSealCheckInfo({
            snaId
          })
          .then(res => {
            if (isSuccess(res)) {
              this.checkFrom = this.formatterData(res.data.obj)
              this.$emit('update:data', this.checkFrom)
            }
          })
      } else {
        checkApi.getPoRerutnPactSealCheckInfo({
          snaId
        }).then(res => {
          if (isSuccess(res)) {
            this.checkFrom = this.formatterData(res.data.obj)
            this.$emit('update:data', this.checkFrom)
          }
        })
      }
    }
  }
}
</script>

<style scoped></style>
